<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">Copy Role Template Permissions</h3>
    </div>
  </div>
  <div class="form">
    <div class="card-body">
      <div>
        <kt-general-autocomplete
          [appearance]="'fill'"
          [label]="'Role Template'"
          [loadItemsFunction]="searchRoleTemplatesFn"
          [optionFormatter]="filterRoleTemplateFn"
          [valueFormatter]="filterRoleTemplateFn"
          [required]="true"
          [readOnly]="disableBtns"
          [control]="roleCtrl"
          [change]="selected.bind(this)"
          [dataPath]="'data'"
          [placeholder]="'Select Role Template'"
          [objects]="roleCtrl.value"
          [formatNewObjectFn]="formatNewRoleTemplateFn"
          #roleTemplateAutoComplete
        ></kt-general-autocomplete>
      </div>
    </div>
    <div class="card-footer">
      <div class="d-flex justify-content-between">
        <div class="mr-2"></div>
        <div>
          <button
            type="button"
            mat-raised-button
            [mat-dialog-close]="false"
            cdkFocusInitial
            [disabled]="disableBtns"
            matTooltip="Cancel changes"
          >
            <span translate="GLOBAL.CANCEL">Cancel</span></button
          >&nbsp;
          <button
            type="button"
            mat-raised-button
            [disabled]="disableBtns"
            color="primary"
            (click)="onSubmit()"
          >
            <span>Select</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
